export default "__VITE_ASSET__BS5q81qN__"